import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import testCaseApi from '../../features/test-cases/services/testCaseApi';

export const fetchTestCases = createAsyncThunk('testCases/fetchTestCases', async (workflowId) => {
  return await testCaseApi.getTestCases(workflowId);
});

export const toggleTestCaseComplete = createAsyncThunk('testCases/toggleComplete', async (id) => {
  await testCaseApi.toggleComplete(id);
  return id;
});

export const reportBug = createAsyncThunk('testCases/reportBug', async (data) => {
  return await testCaseApi.reportBug(data);
});

const testCasesSlice = createSlice({
  name: 'testCases',
  initialState: {
    testCases: [],
    bugs: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTestCases: (state) => { state.testCases = []; state.bugs = []; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestCases.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchTestCases.fulfilled, (state, action) => { state.loading = false; state.testCases = action.payload; })
      .addCase(fetchTestCases.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(toggleTestCaseComplete.fulfilled, (state, action) => {
        const tc = state.testCases.find(t => t.id === action.payload);
        if (tc) tc.completed = !tc.completed;
      })
      .addCase(reportBug.fulfilled, (state, action) => { state.bugs.push(action.payload); });
  },
});

export const { clearTestCases } = testCasesSlice.actions;
export default testCasesSlice.reducer;
